import { observer } from 'mobx-react-lite';
import type { FC } from 'react';
import { msg, msgf } from '@/services/isomorphic/I18NService';
import { Icon, IconSizeProp, IconTypes } from '@/react/components/core-ui/Icon';
import { Button } from '@/react/components/core-ui/Button';
import { Link } from '@/react/components/core-ui/Link';
import type { ISearchSuggestionsProps } from '../../ISearchSuggestionsProps';

import S from './styles.base.module.scss';
import { search_box_frame_keepSearching } from "@/lang/__generated__/ahnu/search_box_frame_keepSearching";
import { search_box_frame_searchAll } from "@/lang/__generated__/ahnu/search_box_frame_searchAll";
import { search_box_frame_removeFromHistory } from "@/lang/__generated__/ahnu/search_box_frame_removeFromHistory";

export const KeepSearchingFor: FC<ISearchSuggestionsProps> = observer(
  ({ vm, onNavigate }) => {
    if (vm.searchHistory.length === 0) {
      return null;
    }

    return (
      <>
        <h3 className={S.title}>{msg(search_box_frame_keepSearching)}</h3>
        <div className={S.container}>
          {vm.searchHistory.map((term) => (
            <div className={S.item} key={`search-history-term-${term}`}>
              <Icon
                className={S.icon}
                icon={IconTypes.Timer}
                size={IconSizeProp.SizeXS}
              />
              <Link
                className={S.term}
                href={vm.encodeSearchResultsPageNavigationUrl(term)}
                onClick={onNavigate}
                aria-label={msgf(search_box_frame_searchAll, { term })}
                title={term}
                variant="text"
              >
                {term}
              </Link>
              <Button
                ariaLabel={msgf(search_box_frame_removeFromHistory, { term })}
                className={S.clearButton}
                onClick={() => vm.deleteTermFromHistory(term)}
                variant="text"
              >
                <Icon
                  className={S.icon}
                  icon={IconTypes.CloseLight}
                  size={IconSizeProp.SizeXS}
                />
              </Button>
            </div>
          ))}
        </div>
      </>
    );
  }
);
